export function capitalizeFirstLetter(str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}export function getStatusColor(status) {
  if (!status) return "default";

  switch (status.toLowerCase()) {
    case "pending":
    case "initiated":
    case "invoiceRaised":
      return "orange";
    case "success":
    case "paid":
    case "received":
    case "active":
      return "green";
    case "failed":
    case "rejected":
    case "cancelled":
      return "red";
    default:
      return "gray";
  }
}

